import type { PublishedAppData } from "./Database";

export type StaticAppConfig = Readonly<{
    dataSnapshot: string;
    appSnapshot: string;
    // FIXME: Add native table snapshots
    publishedAppData: PublishedAppData;
}>;

export function getStaticAppConfig(): StaticAppConfig | undefined {
    try {
        return (window as any).glideStaticConfig;
    } catch {
        return undefined;
    }
}
